var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTribesIconFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10_7684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 22,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2H1.5V22H22.5V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10_7684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0299 2C19.0299 3.22507 18.0631 4.21963 16.8693 4.21963C15.6755 4.21963 14.7087 3.22637 14.7087 2H11.2383V22L22.499 10.3748V2H19.0287H19.0299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.4316V13.9968C2.69251 13.9968 3.66063 14.99 3.66063 16.2164C3.66063 17.4428 2.69377 18.436 1.5 18.436V22.0012H11.2392L9.31938 10.4329H1.5V10.4316Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTribesIconFill);
export default __webpack_public_path__ + "static/media/TribesIconFill.295a4a3acb6f7716b168176bc214a583.svg";
export { ForwardRef as ReactComponent };